export default __webpack_public_path__ + "5b4e38280bcaebf40b7253a5c53067b7.svg";